import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Metric {
  label: string;
  value: string;
  icon: string;
  trend: string;
}

interface StoryMetricsProps {
  metrics: Metric[];
}

const StoryMetrics: React.FC<StoryMetricsProps> = ({ metrics }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {metrics.map((metric, index) => (
        <div
          key={index}
          className="bg-card rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300"
        >
          <div className="flex items-start justify-between mb-4">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={metric.icon as any} size={24} className="text-primary" />
            </div>
            <span className="px-2 py-1 bg-success/10 text-success text-xs font-bold rounded-full">
              {metric.trend}
            </span>
          </div>

          <div className="text-3xl font-headline font-bold text-foreground mb-1">
            {metric.value}
          </div>

          <div className="text-sm text-muted-foreground font-body">{metric.label}</div>
        </div>
      ))}
    </div>
  );
};

export default StoryMetrics;